import EventDetail from "./EventDetail";

export default EventDetail